"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const content = {
  heading: "Sigurnost i Zaštita Vaših Podataka",
  paragraphs: ["Vaša privatnost je naš prioritet. Koristimo najnaprednije protokole enkripcije kako bismo osigurali da su svi vaši osobni podaci i transakcije zaštićeni od neovlaštenog pristupa. Naši sustavi se redovito testiraju kako bi zadovoljili najviše sigurnosne standarde.", "U potpunosti smo usklađeni s GDPR regulativama i lokalnim zakonima o zaštiti privatnosti. Provodimo stroge kontrole pristupa unutar naše organizacije, osiguravajući da samo ovlašteno osoblje može pristupiti nužnim informacijama u svrhu pružanja usluge.", "Naša politika zadržavanja podataka osmišljena je tako da čuvamo samo ono što je neophodno za vaše korisničko iskustvo. Uz kontinuirani nadzor i automatske sigurnosne kopije, vaši su podaci sigurni, dostupni i zaštićeni u svakom trenutku."],
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/data_security_encryption.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/data_security_encryption.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/data_security_encryption.png-wvc-sizes",
    alt: "Ilustracija digitalne sigurnosti i enkripcije podataka"
  }
};
export default function Material() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255580" id="zaštita-podataka" className="py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            {}
            <div className="mb-6 flex items-center gap-3">
              <div className="h-2 w-2 rounded-md bg-secondary" />
              <div className="h-px w-16 bg-secondary/40" />
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-8 leading-tight">
              {content.heading}
            </h2>
            
            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed font-default">
              {content.paragraphs.map((paragraph, index) => <p key={index} data-index={index}>
                  {paragraph}
                </p>)}
            </div>
          </div>

          {}
          <div ref={imgRef} className={`transition-all duration-1000 ease-out delay-200 ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-2xl overflow-hidden bg-muted p-6 md:p-12 flex items-center justify-center shadow-xl">
              <img src={content.image.src} data-wvc-srcset={content.image.srcset} data-wvc-sizes={content.image.sizes} alt={content.image.alt} className="w-full h-auto max-w-md object-contain drop-shadow-3xl hover:scale-105 transition-transform duration-700 ease-in-out" loading="lazy" decoding="async" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}